import { classNames } from '@fullstory/util/fmt';
import React, { ReactNode, useContext } from 'react';
import { Box } from '../../legacy/Box';
import css from './BannerPane.module.scss';
import { BannerContext } from './BannerRoot';

interface BannerPaneProps {
  children: ReactNode;
}

export const BannerPane: React.FC<BannerPaneProps> = ({ children, ...rest }) => {
  const { variant } = useContext(BannerContext);

  return (
    <Box
      data-component="BannerPane"
      className={classNames(css.pane, css[variant])}
      width={1}
      {...rest}
    >
      {children}
    </Box>
  );
};
